export const INITIALIZE = "initialize";
export const SET_AVAILABLE_INTRANETS = "set-available-intranets";
export const SET_PERMISSIONS = "set-roles-for-current-intranet";
export const SET_LOGO = "SET_LOGO";
export const SET_COLORS = "SET_COLORS";
export const RESET_INTRANET_MODULE = "reset-intranet-module";
export const SET_INTRANET = "set-intranet";
export const SET_TEAM_COUNT = "set-team-count";
export const SET_HAS_USER_NAVIGATED_TO_AN_INTRANET = "set-has-user-navigated-to-an-intranet";
